<template>
<div>
    <question-group-component v-for="group in formContent.formGrupoPergunta" :key="group.id" :group="group"></question-group-component>
</div>
</template>


<script>
import QuestionGroupComponent from './QuestionGroupComponent.vue';

export default {
    components: {
        QuestionGroupComponent
    },
    props: {
        formContent: Object
    }
}
</script>
